import { useResource } from '@landsbankinn/l16n';
import {
  BubbleAlertIcon100,
  Button,
  Col,
  H2,
  Row,
  ShortSplitter,
  Span,
} from '@landsbankinn/ui-kit';
import { useEffect, useState } from 'react';
import { useScreenSize } from 'src/hooks/useScreenSize';
import {
  ScopeError,
  useConsentClientContext,
} from '../State/consentClientState';
import { getLocalizedString } from '../utils';
import { res } from './ErrorBox.res';

export function ErrorBox() {
  const [consentClient, consentDispatch] = useConsentClientContext();
  const { r } = useResource();
  const { isMobile } = useScreenSize();

  const [title, setTitle] = useState<string>(r(res.title));
  const [description, setDescription] = useState<string>(r(res.description));

  useEffect(() => {
    if (consentClient.error) {
      switch (consentClient.error) {
        case ScopeError.AccessDenied: {
          setTitle(r(res.title_InvalidUser));
          setDescription(r(res.description_InvalidUser));
          break;
        }
        case ScopeError.Scope: {
          const t = getLocalizedString('error', consentClient.localization);
          const d = getLocalizedString(
            'error_description',
            consentClient.localization,
          );

          if (t) {
            setTitle(t);
          }
          if (d) {
            setDescription(d);
          }
          break;
        }
      }
    }
  }, [consentClient.error, consentClient.localization, r]);
  const errorText =
    getLocalizedString('reject_action', consentClient.localization) ??
    r(res.close);
  return (
    <>
      <Col
        grow="1"
        paddingTop={isMobile ? '60' : undefined}
        paddingHorizontal={isMobile ? '36' : undefined}
        color="blue font"
        background="blue baseLight"
      >
        <Row mainAxisAlignment="space between">
          <Col lg={8} md={8} sm={12}>
            <H2 fontVariant="h3">{title}</H2>
            <ShortSplitter />
            <Row paddingTop="8">
              <Col lg={8} md={8} sm={12}>
                <Span fontVariant="body">{description}</Span>
              </Col>
            </Row>
          </Col>
          {!isMobile && (
            <Col lg={4} md={4}>
              <Row mainAxisAlignment="center">
                <BubbleAlertIcon100 size="150" />
              </Row>
            </Col>
          )}
        </Row>
      </Col>

      <Col
        mainAxisAlignment="center"
        crossAxisAlignment="center"
        marginTop="56"
        paddingTop="58"
        paddingBottom="56"
        paddingHorizontal={isMobile ? '36' : undefined}
        borderTop={isMobile ? 'none' : 'regular 30'}
        background="blue baseLight"
      >
        <Button
          type="button"
          variant={isMobile ? 'secondary' : 'primary'}
          width="100%"
          onClick={() => {
            consentDispatch({ type: 'reject' });
          }}
        >
          {errorText}
        </Button>
      </Col>
    </>
  );
}
